// Mock data for Upxero website – updated concept (Website + Online Ordering + WhatsApp Assistant)

export const testimonials = [
  {
    id: 1,
    name: "Marc Janssens",
    business: "Brasserie De Gouden Leeuw",
    location: "Antwerpen",
    image: "https://images.unsplash.com/photo-1643834776503-891726ed42c6?crop=entropy&cs=srgb&fm=jpg&q=85",
    text: "Sinds we met Upxero werken, krijgen we meer online bestellingen én veel minder telefoontjes. Klanten worden automatisch via WhatsApp geholpen en bestellen direct via onze website. Dat scheelt enorm tijdens de service.",
    rating: 5
  },
  {
    id: 2,
    name: "Sophie Vermeulen",
    business: "Pizzeria La Stella",
    location: "Gent",
    image: "https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg",
    text: "De combinatie van online bestellen en de WhatsApp-assistent is ideaal. Klanten stellen minder vragen en bestellen sneller. Alles ziet er professioneel uit en wij hoeven zelf niets te beheren.",
    rating: 5
  },
  {
    id: 3,
    name: "Dirk Peeters",
    business: "Frituur 't Hoekske",
    location: "Leuven",
    image: "https://images.unsplash.com/photo-1512485800893-b08ec1ea59b1?crop=entropy&cs=srgb&fm=jpg&q=85",
    text: "Vroeger stond de telefoon constant roodgloeiend. Nu stuurt WhatsApp klanten automatisch door naar de bestelpagina. Minder fouten, minder stress en meer controle over onze bestellingen.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "Moet ik commissie betalen per bestelling?",
    answer:
      "Nee. U betaalt een vast maandbedrag. Alle bestellingen via uw website zijn volledig commissievrij, ongeacht het aantal orders."
  },
  {
    id: 2,
    question: "Wat is het verschil tussen de WhatsApp bestel-flow en de AI Assistant?",
    answer:
      "De WhatsApp bestel-flow werkt met vaste, vooraf ingestelde antwoorden en begeleidt klanten naar het online bestelsysteem. De AI Assistant (alleen in Boost) kan vrije vragen begrijpen en beantwoorden en helpt klanten actief bij het bestellen."
  },
  {
    id: 3,
    question: "Neemt de WhatsApp bestel-flow bestellingen aan?",
    answer:
      "Nee. De WhatsApp flow neemt zelf geen bestellingen aan, maar stuurt klanten altijd door naar uw online bestelpagina. Zo vermijdt u fouten en misverstanden."
  },
  {
    id: 4,
    question: "Neemt de AI Assistant bestellingen aan?",
    answer:
      "Nee. Ook de AI Assistant verwerkt geen bestellingen, maar begeleidt klanten stap voor stap naar het online bestelsysteem op uw website."
  },
  {
    id: 5,
    question: "Heb ik technische kennis nodig?",
    answer:
      "Nee. Wij regelen alles voor u: website, online bestellen, WhatsApp flow, AI Assistant (indien inbegrepen), hosting, updates en support."
  },
  {
    id: 6,
    question: "Kan ik mijn menu, prijzen of openingstijden aanpassen?",
    answer:
      "Ja. U kunt uw menu, prijzen en openingstijden eenvoudig aanpassen. Indien gewenst helpen wij u daar ook bij."
  },
  {
    id: 7,
    question: "Hoe snel kan mijn restaurant live gaan?",
    answer:
      "In de meeste gevallen kunnen we binnen 1 à 2 weken live gaan, inclusief website, menu en WhatsApp bestel-flow."
  },
  {
    id: 8,
    question: "Op welke toestellen werkt het systeem?",
    answer:
      "Alles werkt perfect op smartphone, tablet en desktop. Uw website en bestelomgeving zijn volledig mobile-first opgebouwd."
  },
  {
    id: 9,
    question: "Kan ik opzeggen wanneer ik wil?",
    answer:
      "Ja. Er geldt een minimumduur van 6 maanden. Daarna is het abonnement maandelijks opzegbaar."
  },
  {
    id: 10,
    question: "Welke online betaalmethodes zijn mogelijk?",
    answer:
      "Via de optionele Stripe betaalmodule (+€25/maand) kunnen klanten betalen met Bancontact, iDEAL, kredietkaart, Apple Pay en andere populaire betaalmethodes."
  }
];

export const services = [
  {
    id: 1,
    title: "Professionele Horeca Website",
    description:
      "Een snelle, mobile-first website die uw restaurant professioneel presenteert en bezoekers vlot naar online bestellen leidt.",
    icon: "Globe",
    image: "https://images.pexels.com/photos/12935074/pexels-photo-12935074.jpeg"
  },
  {
    id: 2,
    title: "Online Bestellen Zonder Commissie",
    description:
      "Directe bestellingen via uw eigen website voor afhaling en levering. Geen tussenpartijen, geen commissie per bestelling.",
    icon: "ShoppingCart",
    image: "https://images.pexels.com/photos/12935041/pexels-photo-12935041.jpeg"
  },
  {
    id: 3,
    title: "WhatsApp Bestel-flow",
    description:
      "Automatische WhatsApp-berichten met vaste antwoorden die klanten doorsturen naar uw online bestelpagina. Minder telefoons, meer rust tijdens de service.",
    icon: "MessageCircle",
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3"
  },
  {
    id: 4,
    title: "AI Bestel- & Klantenassistent (Boost)",
    description:
      "Een slimme AI-assistent op uw website die vrije vragen beantwoordt en klanten actief helpt bestellen — 24/7, zonder extra personeel.",
    icon: "Bot",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995"
  },
  {
    id: 5,
    title: "Volledig Beheerde Oplossing",
    description:
      "Hosting, updates, beveiliging en support inbegrepen. U focust op uw zaak, wij regelen de techniek.",
    icon: "Settings",
    image: "https://images.unsplash.com/photo-1558655146-364adaf1fcc9"
  }
];

export const benefits = [
  {
    id: 1,
    title: "0% Commissie, 100% Uw Omzet",
    description:
      "U behoudt elke euro van uw bestellingen. Geen commissie per order, enkel een vast en transparant maandbedrag.",
    icon: "TrendingUp",
    image: "https://images.pexels.com/photos/12935048/pexels-photo-12935048.jpeg"
  },
  {
    id: 2,
    title: "Minder Telefoons, Minder Fouten",
    description:
      "Klanten krijgen automatisch duidelijke antwoorden en bestellen zelf online. Minder onderbrekingen en minder misverstanden.",
    icon: "PhoneOff",
    image: "https://images.pexels.com/photos/9461799/pexels-photo-9461799.jpeg"
  },
  {
    id: 3,
    title: "Meer Directe Bestellingen",
    description:
      "Klanten bestellen rechtstreeks via uw eigen website in plaats van via externe platformen. Meer controle, hogere marges en meer herhaalbestellingen.",
    icon: "Target",
    image: "https://images.pexels.com/photos/6605239/pexels-photo-6605239.jpeg"
  },
  {
    id: 4,
    title: "Groei Zonder Extra Personeel",
    description:
      "Automatisatie en AI nemen klantvragen en bestellingen over, zodat uw team zich kan focussen op de service in de zaak.",
    icon: "UserCheck",
    image: "https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Start",
    price: "19",
    period: "maand",
    setupPrice: 100,
    description:
      "Voor restaurants met een bestaande website die online willen verkopen én 1 vacature willen publiceren.",
    features: [
      "Online bestelsysteem voor afhaling & levering",
      "WhatsApp bestel-flow (vaste antwoorden, geen AI)",
      "Menu setup & volledige integratie",
      "Hosting, updates & beveiliging",
      "1 actieve vacature op Talent by Upxero",
      "Publicatie op talent.upxero.com",
      "Email support"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Grow",
    price: "29",
    period: "maand",
    setupPrice: 200,
    description:
      "Complete professionele horeca website met automatisatie, domeinnaam en verhoogde zichtbaarheid.",
    features: [
      "Professionele horeca website (mobile-first)",
      "Online bestelsysteem voor afhaling & levering",
      "WhatsApp bestel-flow (vaste antwoorden, geen AI)",
      "Klanten automatisch doorsturen naar online bestellen",
      "Menu setup & integratie",
      "Hosting, updates & beveiliging",
      "Domeinnaam inbegrepen (.be / .nl / .eu / .com)",
      "2 professionele business e-mail accounts",
      "3 actieve vacatures op Talent by Upxero",
      "⭐ Featured vacature badge",
      "Voorrang in zoekresultaten",
      "Email support"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Boost",
    price: "49",
    period: "maand",
    setupPrice: 250,
    description:
      "Voor restaurants die maximale groei willen: AI automatisatie, premium zichtbaarheid en volledige business infrastructuur.",
    features: [
      "Alles uit Grow",
      "AI Bestel- & Klantenassistent (24/7)",
      "AI beantwoordt vrije vragen (menu, allergenen, openingstijden)",
      "AI stuurt klanten actief naar online bestellen",
      "Conversie-optimalisatie",
      "Google Business integratie",
      "Rapportage & continue optimalisatie",
      "5 professionele business e-mail accounts",
      "5 actieve vacatures op Talent by Upxero",
      "🚀 Prioritaire vacatureplaatsing",
      "Extra promotionele ondersteuning",
      "Prioriteit support & persoonlijk advies"
    ],
    popular: false
  }
];

export const stats = [
  { label: "Tevreden Restaurants", value: "50+", icon: "Users" },
  { label: "Bestellingen per Maand", value: "10.000+", icon: "ShoppingBag" },
  { label: "Minder Telefonische Bestellingen", value: "−60%", icon: "PhoneOff" },
  { label: "Support Responstijd", value: "<2u", icon: "Clock" }
];

